/* eslint-env browser */
/*
 * Add dismiss functionality to all alert messages with this plugin. Only takes effect for buttons
 * with [data-dismiss="alert"] with a class of .close, as a first child to .alert-dismissable
 *
 * https://getbootstrap.com/docs/3.4/javascript/#alerts
 */
require('../bootstrap/js/alert');
